import {store} from '..';
import { call, put } from 'redux-saga/effects';
import { url } from '../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';

const createCorrectionAPI = (value) => {

    return APICallingService.sendRequestForPostWithAuth(url.addCorrection, value, false, (res) => {

    }, true);
}

function* createCorrection(action) {
    try {
        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(createCorrectionAPI, action.payload.value);
        if (response && response?.callBackStatus?.toLowerCase() == 'success') {
            alert("Trailer Place Successfully");
            yield put({
                type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.ADD_COORECTION_API_CALL_SUCCESS, payload: { value: response?.callBackStatus }
            });
        }
        else {
            if (response && response != null && response.Status != 405) {

                yield put({
                    type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.ADD_COORECTION_API_CALL_SUCCESS, payload: { value: response?.callBackStatus }
                });
                alert('Failed to get Data');
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.ADD_COORECTION_API_CALL_SUCCESS, payload: { value: 'Failed' } });
    }
}

const getCorrectionsLogAPI = (action) => {
    let urlLog = url.getCorrectionLog + action.pageSize + "/" + action.limit;
    return APICallingService.sendRequestForGet(urlLog, (res) => {

    }, true);
}

function* getCorrectionsLog(action) {

    try {

        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });
        const response = yield call(getCorrectionsLogAPI, action.payload.value);
        if (response && response != null) {
            yield put({
                type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.GET_CORRECTION_LOG_API_CALL_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                yield put({
                    type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.GET_CORRECTION_LOG_API_CALL_SUCCESS, payload: { value: response.data }
                });
            }
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_CORRECTION_MANAGEMENT.GET_CORRECTION_LOG_API_CALL_SUCCESS, payload: { value: 'Failed' }
        })
    }
}


export { createCorrection, getCorrectionsLog };
